import z from 'zod';

export const moduleTopicSchema = z.object({
  topic: z.string(),
  category: z.string(),
  detail: z.string().optional(),
});

export type ModuleTopic = z.infer<typeof moduleTopicSchema>;
